import { Link } from "react-router-dom";

const TABS = [
  { key: "overview", label: "总览", to: "/admin/vehicle-operations" },
  { key: "maintenance", label: "维修工单", to: "/admin/vehicle-operations/maintenance" },
  { key: "expenses", label: "费用证照", to: "/admin/vehicle-operations/expenses" },
];

export function VehicleOpsTabs({ active }: { active: "overview" | "maintenance" | "expenses" }) {
  return (
    <div className="flex gap-1 border-b border-slate-200">
      {TABS.map((t) => (
        <Link
          key={t.key}
          to={t.to}
          className={`-mb-px border-b-2 px-4 py-2.5 text-[14px] font-medium ${
            active === t.key
              ? "border-blue-600 text-blue-700"
              : "border-transparent text-slate-500 hover:text-slate-800"
          }`}
        >
          {t.label}
        </Link>
      ))}
    </div>
  );
}
